module.exports = __webpack_public_path__ + "img/development-charter.45bbbafe.svg";